export const configConstant = {
    GET_CONFIG_REQUEST: "GET_CONFIG_REQUEST",
    GET_CONFIG_SUCCESS: "GET_CONFIG_SUCCESS",
    GET_CONFIG_FAILURE: "GET_CONFIG_FAILURE",

        
    GET_SEO_REQUEST: "GET_SEO_REQUEST",
    GET_SEO_SUCCESS: "GET_SEO_SUCCESS",
    GET_SEO_FAILURE: "GET_SEO_FAILURE",
} 